document.addEventListener('DOMContentLoaded', function() {
 
  let prosection = document.querySelector('.template-index .shopify-section.section-product-list');
  let colsection = document.querySelector('.template-index .shopify-section.section-collection-list');  
  let colsectiondesk = document.querySelector('.template-index .shopify-section.section-collection-product');  

  if (window.innerWidth < 749) { 
    if (prosection) {
      prosection.remove();
    }
    if (colsection) {
      colsection.remove();
    }
  }

  if (window.innerWidth > 749) { 
    if (colsectiondesk) {
      colsectiondesk.remove();
    }
  }

});


// document.addEventListener('DOMContentLoaded', function () {
//   let cusvideos = document.querySelectorAll('.template-index video.cus-video');
//   let colcusvideos = document.querySelectorAll('.template-collection video.cus-video');

//   cusvideos.forEach(function(video) {
//     video.play().catch(function(error) {
//       console.warn('Video play failed:', error);
//     });
//   });

//   colcusvideos.forEach(function(video) {
//     video.play().catch(function(error) {
//       console.warn('Video play failed:', error);
//     });
//   });

// });

window.onload = function () {
  let cusvideos = document.querySelectorAll('.template-index video.cus-video');
  let colcusvideos = document.querySelectorAll('.template-collection video.cus-video');

  cusvideos.forEach(function(video) {
    video.play().catch(function(error) {
      console.warn('Video play failed (template-index):', error);
    });
  });

  colcusvideos.forEach(function(video) {
    video.play().catch(function(error) {
      console.warn('Video play failed (template-collection):', error);
    });
  });
};



// document.addEventListener('DOMContentLoaded', function() {
//     if (window.innerWidth <= 768) { 
//         function playActiveVideo() {
//             var videos = document.querySelectorAll('.custom-video-wrapper .owl-item video');

//             videos.forEach(function(video) {
//                 if (!video.paused) {
//                     video.pause(); 
//                 }
//             });

//             var activeVideo = document.querySelector('.custom-video-wrapper .owl-item.active video');
//             if (activeVideo && activeVideo.paused) {
//                 activeVideo.play(); 
//             }
//         }

//         playActiveVideo();

//         var owlCarousel = document.querySelector('.owl-carousel');
//         if (owlCarousel) {
//             owlCarousel.addEventListener('changed.owl.carousel', function(event) {
//                 playActiveVideo();
//             });
//         }
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) { 
        // Function to play only the video of the first active slide
        function playActiveVideo() {
            var videos = document.querySelectorAll('.custom-video-wrapper .owl-item video');
            
            // Pause all videos first
            videos.forEach(function(video) {
                video.pause(); 
            });

            // Find the first active .owl-item
            var activeItem = document.querySelector('.custom-video-wrapper .owl-item.active');

            // If there is an active item, play the video inside it (if it's paused)
            if (activeItem) {
                var activeVideo = activeItem.querySelector('video');
                if (activeVideo && activeVideo.paused) {
                    activeVideo.play(); 
                }
            }
        }

        // Initial play when DOM is ready
        playActiveVideo();

        // Manual slide change event (simulate your own custom slide change)
        var carouselWrapper = document.querySelector('.custom-video-wrapper');
        if (carouselWrapper) {
            carouselWrapper.addEventListener('transitionend', function() {
                playActiveVideo(); // When a new slide is active, play the video in the first active slide
            });
        }
    }
});



